import { Link } from "react-router-dom";
import ScrollReveal from "./ScrollReveal";

const credentials = [
  "CCSS Auditor (C4) — cryptocurrency security standard",
  "DEFCON speaker at age 20",
  "Y-Combinator W17 (Apozy)",
  "18 years in security: KeyBank InfoSec, Hurricane Labs, Bishop Fox / Stach & Liu",
];

export default function MeetTheOperator() {
  return (
    <section id="meet-the-operator" aria-label="Meet the Operator" className="editorial-container section-spacing">
      <hr className="editorial-rule mb-16 lg:mb-20" />

      {/* Label */}
      <ScrollReveal>
        <p className="font-mono text-label uppercase tracking-[0.05em] text-accent">
          MEET THE OPERATOR
        </p>
      </ScrollReveal>

      {/* Headline */}
      <ScrollReveal stagger={1}>
        <h2 className="mt-6 max-w-3xl font-display text-section font-bold text-foreground md:text-section-md lg:text-section-lg">
          The person behind the system.
        </h2>
      </ScrollReveal>

      <div className="mt-10 grid gap-12 lg:grid-cols-[2fr_1fr] lg:gap-16">
        {/* Bio */}
        <div className="max-w-3xl space-y-6">
          <ScrollReveal stagger={2}>
            <p className="text-body-lg text-foreground-muted md:text-body-lg-md">
              I&rsquo;m Rick. I break things for a living, then build them better.
            </p>
          </ScrollReveal>

          <ScrollReveal stagger={3}>
            <p className="text-body-lg text-foreground-muted md:text-body-lg-md">
              18 years as a hacker, founder, and operator. DEFCON stage at 20.
              Y-Combinator backed. Built browser security platforms used by
              Coinbase, Uber, and Gemini. Grew a company from zero to 650,000+
              daily users, securing over $100M in digital assets. Co-founded a
              business that hit 70% profitability before acquisition by Hagerty.
            </p>
          </ScrollReveal>

          <ScrollReveal stagger={4}>
            <p className="text-body-lg text-foreground-muted md:text-body-lg-md">
              I&rsquo;ve been the first hire, the CEO, the CTO, and the guy
              awake at 3am because production is down. I know what zero feels
              like. I know what ten looks like. I&rsquo;ve done SOC 2, threat
              modeling, incident response, and enterprise security reviews from
              both sides of the table.
            </p>
          </ScrollReveal>

          <ScrollReveal stagger={5}>
            <p className="text-body-lg text-foreground-muted md:text-body-lg-md">
              Now I use everything I&rsquo;ve learned, plus AI that actually
              works, to help founders skip the mistakes I made and get to
              traction faster.
            </p>
          </ScrollReveal>

          <ScrollReveal className="mt-8">
            <Link
              to="/about"
              className="group inline-flex items-center gap-2 font-body text-cta uppercase text-accent transition-all duration-300 hover:gap-4"
            >
              FULL BIO &amp; BACKGROUND
              <span aria-hidden="true" className="inline-block transition-transform duration-300 group-hover:translate-x-0.5">→</span>
            </Link>
          </ScrollReveal>
        </div>

        {/* Credentials sidebar */}
        <ScrollReveal stagger={3}>
          <div className="border-l-2 border-accent bg-accent-subtle p-6">
            <p className="font-mono text-label uppercase tracking-[0.05em] text-accent">
              CREDENTIALS
            </p>
            <ul className="mt-4 space-y-3">
              {credentials.map((cred) => (
                <li key={cred} className="flex items-start gap-3">
                  <span aria-hidden="true" className="mt-1 shrink-0 text-accent">▸</span>
                  <span className="text-small text-foreground-muted">{cred}</span>
                </li>
              ))}
            </ul>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
